import React from 'react';
import { ScrollView as RNScrollView } from 'react-native';

export type ScrollViewProps = React.ComponentProps<typeof RNScrollView>;

export default function ScrollView(props: ScrollViewProps) {
  return (
    <RNScrollView
      keyboardShouldPersistTaps="handled"
      removeClippedSubviews={false}
      showsHorizontalScrollIndicator={false}
      showsVerticalScrollIndicator={false}
      {...props}
    />
  );
}
